import { CountWithComparison } from '@/models';

export const getCountChange = (
  count: CountWithComparison | null | undefined,
  changeNotInPercentageValue?: boolean,
): number | null => {
  if (!count || count.current == null || count.previous == null || count.previous === 0) {
    return null;
  }
  return changeNotInPercentageValue
    ? count.current - count.previous
    : (count.current - count.previous) / count.previous;
};
